
import React, { useState, useEffect } from "react";
import './LeftSidebar.css';
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, Layout } from 'antd';
import {
  HomeOutlined,
  DashboardOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  SettingOutlined,
  FileTextOutlined,
  AppstoreOutlined,
  TeamOutlined,
  BarChartOutlined,
  FileOutlined,
} from '@ant-design/icons';
import getMenuItems from "../components/MenuItems";
import getMenuItems_vat from "../components/Menu_item_vat";
import fetchData from "../functions/fetchData";

const { Sider } = Layout;


export default function LeftSidebar({ usertype, isOpen, isMobile, onClose }) {
  const [menuItems, setMenuItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    // Fetch tax_type from coresetting and set menu accordingly
    async function fetchTaxTypeAndMenu() {
      setMenuItems(getMenuItems_vat(usertype));
    }
    fetchTaxTypeAndMenu();
  }, [usertype]);

  // Update selected keys based on current route
  useEffect(() => {
    const currentPath = location.pathname;
    setSelectedKeys([currentPath]);
  }, [location.pathname]);

  // Icon mapping for menu items
  const getIcon = (iconName) => {
    const iconMap = {
      'home': <HomeOutlined />,
      'dashboard': <DashboardOutlined />,
      'view-dashboard': <DashboardOutlined />,
      'shopping-cart': <ShoppingCartOutlined />,
      'store': <ShoppingCartOutlined />,
      'accounts': <UserOutlined />,
      'account': <UserOutlined />,
      'settings': <SettingOutlined />,
      'file-text': <FileTextOutlined />,
      'receipt': <FileTextOutlined />,
      'apps': <AppstoreOutlined />,
      'collection': <AppstoreOutlined />,
      'assignment': <FileOutlined />,
      'chart': <BarChartOutlined />,
      'balance': <BarChartOutlined />,
      'money': <BarChartOutlined />,
      'group': <TeamOutlined />,
    };
    
    // Return icon if mapped, otherwise return default
    return iconMap[iconName] || <FileOutlined />;
  };

  // Convert menu items to Ant Design format
  const convertToAntMenuItems = (items) => {
    return items.map((item, index) => {
      if (item.submenu) {
        return {
          key: `submenu-${index}`,
          icon: getIcon(item.icon),
          label: item.name,
          children: item.submenu.map((subItem, subIndex) => ({
            key: subItem.path,
            label: subItem.name,
          })),
        };
      } else {
        return {
          key: item.path || `menu-${index}`,
          icon: getIcon(item.icon),
          label: item.name,
        };
      }
    });
  };

  const handleMenuClick = ({ key, keyPath }) => {
    // Navigate to the selected route
    if (key && !key.startsWith('submenu-')) {
      navigate(key);
      // Close sidebar on mobile when clicking a menu item
      if (isMobile) {
        onClose();
      }
    }
  };

  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  return (
    <Sider
      collapsible
      collapsed={!isOpen}
      onCollapse={() => {}}
      breakpoint={isMobile ? "lg" : undefined}
      collapsedWidth={isMobile ? 0 : 60}
      width={240}
      trigger={null}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: isMobile ? 0 : 60,
        bottom: 0,
        zIndex: isMobile ? 2000 : 1050,
        background: '#001529',
        boxShadow: isMobile && isOpen ? '2px 0 8px rgba(0,0,0,0.15)' : 'none',
        transition: 'all 0.2s',
      }}
      className={`left-sidebar-ant ${isMobile && isOpen ? "mobile-open" : ""}`}
    >
      <div style={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        paddingTop: isMobile ? 16 : 8,
      }}>
        {/* Main Menu Section */}
        {isOpen && (
          <div style={{ 
            padding: '8px 16px', 
            color: '#ffffff40', 
            fontSize: '12px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}>
            Main
          </div>
        )}
        
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKeys}
          openKeys={openKeys}
          onClick={handleMenuClick}
          onOpenChange={handleOpenChange}
          items={convertToAntMenuItems(menuItems)}
          style={{
            borderRight: 0,
            flex: 1,
            background: 'transparent',
          }}
        />

        {/* Settings Section */}
        {isOpen && (
          <div style={{ 
            padding: '8px 16px', 
            color: '#ffffff40', 
            fontSize: '12px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginTop: 'auto',
          }}>
            Settings
          </div>
        )}
      </div>
    </Sider>
  );
}
